import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "block" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "block-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_rate = _resolveComponent("a-rate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", {
      class: "block-desc",
      innerHTML: _ctx.text
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_a_rate, {
        value: _ctx.rateValue,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.rateValue) = $event)),
        "allow-clear": "",
        style: {"color":"var(--brand-color, #1d8de1)"}
      }, null, 8, ["value"])
    ])
  ]))
}